import React, { useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import UserProfile from "../../components/User/UserDetail";
import { getICAIUserDetailDataApi } from "../../../services/apis/ICAIUsersApi";
import { useParams } from "react-router-dom";

const UserDetail = () => {
  const id = useParams()?.id;
  const [userDetail,setUserDetail]=useState({});

  const getUserDetail = async () => {
    try {
      const res = await getICAIUserDetailDataApi(id);
      const u_data = res?.data?.data;
      setUserDetail(u_data)
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(()=>{
    getUserDetail();
  },[]);

  return (
    <>
      {/* <PageTitle activeMenu={"Professor Profile"} motherMenu={"Professors"}/> */}
      <UserProfile userD={userDetail}/>
    </>
  );
};

export default UserDetail;
